import { render, staticRenderFns } from "./SpkCreate.vue?vue&type=template&id=02da9696&"
import script from "./SpkCreate.vue?vue&type=script&lang=js&"
export * from "./SpkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports